<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Ajouter une fiche de stock</h3>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <Form ref="ficheStockForm" @submit="addFicheStock" :validation-schema="ficheStockSchema">
            <div class="row">
              <div class="col-md-4 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label for="date" class="d-block text-black fw-semibold mb-10">Date création<span class="text-danger">*</span></label>
                  <Field name="dateCreation" :value="getCurrentDate()" class="form-control" type="Date"/>
                  <ErrorMessage name="dateCreation" class="text-danger" />
                </div>
              </div>
              <div class="col-md-8  mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Produit 
                  </label>
                  <Field name="produit" v-model="produit" type="text" v-slot="{ field }">
                    <Multiselect
                      v-model="field.value" 
                      v-bind="field"
                      :options="produitOptions" 
                      :searchable="true"
                      placeholder="Sélectionner un produit"
                      @select="selectProd(field.value)"
                    />
                  </Field>
                  <ErrorMessage name="produit" class="text-danger"/>
                  <!-- <span class="text-danger" v-if="showMErr">Le produit est obligatoire</span> -->
                </div>
              </div>
              <div class="col-md-6 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black">
                    Magasin <span class="text-danger">*</span>
                  </label>
                  <Field name="magasin" v-model="magasins" type="text" v-slot="{ field }">
                    <Multiselect v-model="field.value" v-bind="field" :options="magasinOptions" :preserve-search="true" mode="tags"
                      :multiple="false" :searchable="true" placeholder="Sélectionner le magasin "
                      label="label" track-by="label" />
                  </Field>
                  <ErrorMessage name="magasin" class="text-danger"/>
                  <!-- <span class="text-danger" v-if="showMErr">Le magasin est obligatoire</span> -->
                </div>
              </div>
              <div class="col-md-3">
                    <label for="stockInit" class="d-block text-black fw-semibold mb-10">Stock Initial</label>
                    <Field name="stockInit" class="form-control" type="text"/>
                    <ErrorMessage name="stockInit" class="text-danger" />
              </div>
              <div class="col-md-3 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black  mb-10">
                    Unité de suivie <span class="text-danger">*</span>
                  </label>
                  <Field name="conditionnement" type="text" v-slot="{ field }">
                    <Multiselect 
                      v-model="field.value" 
                      v-bind="field"  
                      :options="conditionnementOptions" 
                      :searchable="true" 
                      track-by="label"
                      label="label" 
                      placeholder="Sélectionner le conditionnement" />
                  </Field>
                  <ErrorMessage name="conditionnement" class="text-danger"/>
                </div>
              </div>
              <div class="col-md-12 mt-3">
                <div class="d-flex align-items-center ">
                  <button ref="submitButton" class="btn btn-success me-3" type="submit">
                      Ajouter une fiche
                  </button>
                  <router-link to="/fiches/liste-fiches"  class=" btn btn-danger"><i  class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                      <span class="position-relative"></span>Annuler
                  </router-link>
                </div>
              </div>
        </div>
    </Form>
  </div>
</div>
</template>
<script lang="ts">

import { defineComponent, onMounted, ref} from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import ApiService from '@/services/ApiService';
import { error, success } from '@/utils/utils';
import { useRouter } from 'vue-router';
import Multiselect from '@vueform/multiselect/src/Multiselect';
import VueMultiselect from 'vue-multiselect'
export default defineComponent({
    name: "AddFicheStock",
    components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
    VueMultiselect
  },

  setup: () => {
    const ficheStockSchema = Yup.object().shape({
        stockInit: Yup.string().notRequired(),
        dateCreation: Yup.date().typeError("veuillez entrer une date valide").required("La date est obligatoire."),
        magasin: Yup.array().required("le magasin  est obligatoire."),
        produit: Yup.string().required("le produit  est obligatoire."),
        conditionnement: Yup.string().required("le produit  est obligatoire.")
    });

    onMounted(() => {
      getAllProduits(),
      getAllMagasin()
    });

    const selectProd = (prod) => {
      console.log(prod,"selectedMagasinselectedMagasinselectedMagasin")
      if(prod != null && prod != undefined){
        fetchConditionnementProduis(prod.split("|")[0]);
      }else{
        conditionnementOptions.value = [];
      }
    };
    
    const ficheStockForm =  ref(null);
    const showMErr = ref(false);
    const produitOptions = ref([]);
    const conditionnementOptions = ref([]);
    const submitButton = ref<HTMLButtonElement | null>(null);
   
    const magasins = ref([]);
    const isDis =  ref(true);
    //const permissions = ref(null);
    
    const magasinOptions = ref([]);
    const router = useRouter();
    //const permissions= ref<Array<Permission>>([]);
    const addFicheStock = async (values: any, { resetForm }) => { 
      if (submitButton.value) {
        // eslint-disable-next-line
        submitButton.value.disabled = true;
      }

    console.log('Données envoyées', values)
    var produit = values['produit'];
    var conditionnement = values['conditionnement'];
    values['produit'] = produit.split("|")[0];
    values['nomProduit'] = produit.split("|")[2] +" "+ produit.split("|")[3];
    values['refProduit'] = produit.split("|")[1];
    values['conditionnement'] = conditionnement.split("|")[0];
    values['libelleCod'] = conditionnement.split("|")[1];
    if (showMErr.value === false) {
      ApiService.post("/ficheproduit", values)
         .then(({ data }) => {
           if (data.code == 201) {
            success(data.message);
             //resetForm();
           console.log('flefelef')
            router.push({ name: "ListeFicheStock" });
         }
         }).catch(({ response }) => {
          submitButton.value!.disabled = false;
          error(response.data.message);
        });
     }
  };
    
    const produit = ref();
    const magasin = ref();

    const fetchConditionnementProduis = async (produit) => {
      ApiService.get("/conditionnement/produit/"+produit)
      .then(({ data }) => {
        const donnees = data.data;
        conditionnementOptions.value = donnees.map((condi) => {
          return {
            value: `${condi.id}|${condi.libelle}`,
            label: condi.libelle,
          }
        });
      })
      .catch(({ response }) => {
        // error(response.data.message)
      });
    }

    const getAllProduits = async () => {
      try{
        const response = await ApiService.get('/produits');
        const produitsData = response.data.data;
        produitOptions.value = produitsData.map((produit) => ({
            value:`${produit.id}|${produit.codeProduit}|${produit.nomProd}|${produit.refProd}`,
            label:`${produit.codeProduit}|${produit.nomProd}|${produit.refProd}`,
          }));
      }
      catch(error){
        //error(response.data.message)
      }
    } 

    const getAllMagasin = async () => {
      try{
        const response = await ApiService.get('/all/all/magasins');
        const magasinsData = response.data.data;
        console.log(magasinsData,"gggggggggg");
        magasinOptions.value = magasinsData.map((magasin) => ({
          value: magasin.id +"|"+ magasin.code,
          label:  magasin.code + ' - ' + magasin.nomMagasin + ' du ' + magasin.magasin.nomMagasin,
        }));
      }
      catch(error){
        //error(response.data.message)
      }
    }

    const getCurrentDate = () => {
      const today = new Date();
      return today.toISOString().split('T')[0];
    }
    
    return { ficheStockSchema, getCurrentDate, submitButton, conditionnementOptions, selectProd,addFicheStock, ficheStockForm, showMErr,magasinOptions,magasins,magasin,produitOptions,produit};
  },
});
</script>